module.exports = require('./index').defaults({credentials: 'same-origin'});
